import {API_DRIVER} from "../config/axios";

const ServerService = {
    fetchServerTime: () => {
        return API_DRIVER.get('/api/server_time')
    }
}

export default ServerService
